// extracted by mini-css-extract-plugin
export default {"radioGroup":"TariffsListMobile__radioGroup--2qv7k"};